import { css } from '@/styled-system/css';

export const upsellContentStyles = css.raw({
  flexGrow: 1,
});
